import { Component, OnInit } from '@angular/core';
import { HtmlParser } from '@angular/compiler';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(private http : HttpClient, private modalService: BsModalService) { }

  ngOnInit() {
  }

  address: string;

  message: string;

  modalRef: BsModalRef;

  sendMail(modalRef: BsModalRef)
  {
    let url="http://pdftotableapi.pascaldeclercq.be";
    //let url="http://localhost:65371/";
    this.http.post(url+"/api/mail", {From :this.address, To: "info@pascaldeclercq.be", Subject:"Mail from pdf to table sent by "+this.address, Body:this.message, IsBodyHtml: true}).subscribe(data=>{
      this.modalRef= this.modalService.show(modalRef);
    });

  }
}
